import type { IconSvgObject } from './types';

const FormIcon: IconSvgObject = [
  ["path", { d: "M19 8H5C4.44772 8 4 8.44772 4 9V11C4 11.5523 4.44772 12 5 12H19C19.5523 12 20 11.5523 20 11V9C20 8.44772 19.5523 8 19 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 4H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 16H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 20H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FormIcon;
